import { call } from 'redux-saga/effects';
import { pong } from 'features/application/actions';
import { RTCClient } from 'utils/webrtc';
import { emitTurnRenewalRejected } from 'utils/webrtc/iceTelemetry';
import { iceServerListProblem } from 'utils/webrtc/turnCredentials';

export function* refreshIceServersSaga(action: ReturnType<typeof pong>) {
  const { iceServers } = action.payload;

  if (iceServers === undefined) {
    return;
  }

  const problem = iceServerListProblem(iceServers);

  if (problem) {
    yield call(emitTurnRenewalRejected, { problem });
    return;
  }

  yield call(RTCClient.mediaServerConnector.updateIceServers, iceServers);
}
